import { Header } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const HeadingText = Header.withConfig({
  textAlign: 'center',
});

export const BodyText = withTypography({ fontSize: 'md', textAlign: 'center', mb: '$4' });
